import { IAsset } from '../../../lib/types';

export enum ViewerType {
  PDF = 'PDF',
  IMAGE = 'IMAGE',
  TEXT = 'TEXT',
  OFFICE = 'OFFICE',
  UNSUPPORTED = 'UNSUPPORTED',
}

export interface IDocumentViewerModalProps {
  open: boolean;
  onClose: () => void;
  asset: IAsset;
  requestToken?: string;
}

export interface IPdfViewerProps {
  url: string;
  authorization?: string;
  requestToken?: string;
}

export interface IImageViewerProps {
  url: string;
  alt: string;
}

export interface ITextViewerProps {
  url: string;
  fileName: string;
}

export interface IOfficeViewerProps {
  url: string;
  fileName: string;
}
